const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: "csea-nitg.firebaseapp.com",
    projectId: "csea-nitg",
    storageBucket: "csea-nitg.appspot.com",
    messagingSenderId: "643193517246",
    appId: "1:643193517246:web:2ab0bf8ff6afe02afedaef"
  };
export default firebaseConfig;